import { FC } from "react";
import { HorizontalTabNavigation } from "@/components/HorizontalTab/HorizontalTabNavigation";
import { isEditing } from "@builder.io/sdk-react";

export const HorizontalTabNavigationBlock: FC = () => (
  <HorizontalTabNavigation tabClickOverride={isEditing()} />
);
